import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import Button from 'react-bootstrap/Button'

import { getEventMenuContext } from '../../utilities/api'
import {
  buildEventMenuPath,
  getOrderFoodLinkContext,
} from '../../utilities/fnbMenu'

export default function OrderFoodButton({
  order,
  event,
  className = '',
  variant = 'primary',
}) {
  const [menuPath, setMenuPath] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let cancelled = false
    setLoading(true)
    setMenuPath(null)

    const directContext = getOrderFoodLinkContext(order, event)
    if (directContext?.menuPath) {
      if (!cancelled) {
        setMenuPath(directContext.menuPath)
        setLoading(false)
      }
      return () => {
        cancelled = true
      }
    }

    if (!directContext?.eventUuid || !directContext?.section) {
      setLoading(false)
      return () => {
        cancelled = true
      }
    }

    getEventMenuContext(directContext.eventUuid, {
      section: directContext.section,
      row: directContext.row,
      seat: directContext.seat,
    })
      .then((res) => {
        if (cancelled) return
        const data = res?.data
        if (data?.enabled === false) {
          setMenuPath(null)
          return
        }
        if (data?.menuPath) {
          setMenuPath(data.menuPath)
          return
        }
        if (data?.enabled && data?.organizationUuid && data?.section) {
          setMenuPath(
            buildEventMenuPath({
              organizationUuid: data.organizationUuid,
              venueUuid: data.venueUuid,
              sectionName: data.section,
              row: data.row,
              seat: data.seat,
              eventUuid: data.eventUuid,
            })
          )
        }
      })
      .catch(() => {
        if (!cancelled) setMenuPath(null)
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => {
      cancelled = true
    }
  }, [order, event])

  if (loading || !menuPath) return null

  return (
    <Button as={Link} to={menuPath} variant={variant} className={className}>
      Order food &amp; drinks
    </Button>
  )
}
